import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingPliRequiredUK: {
    id: 'charity.vetting.uk.pli.required',
    defaultMessage: 'Please enter an amount',
  },
  charityVettingRegistrationIdRequiredUK: {
    id: 'charity.vetting.uk.registration.id.required',
    defaultMessage: 'Please enter your charity number',
  },
  charityVettingCompanyNumberRequiredUK: {
    id: 'charity.vetting.uk.company.number.required',
    defaultMessage: 'Please enter your company registration number',
  },
});
